<!-- <p>user-self-attendnace-dialog works!</p> -->
<div
  [ngClass]="{
    'self-employee-attendance-component':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'self-employee-attendance-component-mobile': screenSize == ScreenType.Mobile
  }"
>
  <div class="aumye-header">
    Self Verification
    <button mat-mini-fab mat-dialog-close>
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="self-employee-content">
    <div class="camera-container">
      <div class="location-container">
        <!-- <div class="note-message"><i>Your location is required!</i> <b></b></div> -->
        <!-- Initial Request -->
        <div *ngIf="status === 'initial'" class="note-message alert alert-info">
          <i>Your location is required!</i>
          <button (click)="getCurrentLocation()" class="btn btn-primary ml-2">
            Enable Location
          </button>
        </div>

        <!-- Requesting -->
        <div *ngIf="status === 'requesting'" class="alert alert-warning">
          <i class="fas fa-spinner fa-spin"></i>
          Please allow location access in the browser prompt.
        </div>

        <!-- Success -->
        <div *ngIf="status === 'success'" class="alert alert-success">
          <i class="fas fa-check-circle"></i>
          Location successfully fetched!
          <!-- <div *ngIf="currentLocation">
            Latitude: {{ currentLocation.latitude.toFixed(6) }}, Longitude:
            {{ currentLocation.longitude.toFixed(6) }}
          </div> -->
        </div>

        <!-- Error -->
        <div *ngIf="status === 'error'" class="alert alert-danger">
          <i class="fas fa-exclamation-circle"></i>
          {{ errorMessage }}
          <button (click)="getCurrentLocation()" class="btn btn-danger ml-2">
            Try Again
          </button>
        </div>

        <!-- Permission Denied -->
        <div *ngIf="status === 'denied'" class="alert alert-danger">
          <i class="fas fa-ban"></i>
          Location permission was denied.
          <button (click)="getCurrentLocation()" class="btn btn-danger ml-2">
            Try Again
          </button>
        </div>
      </div>
      <div class="camera-status">
        <!-- Initial Request -->
        <div
          *ngIf="cameraStatus === 'initial'"
          class="note-message alert alert-info"
        >
          <i>Camera access is required!</i>
          <button (click)="initializeCamera()" class="btn btn-primary ml-2">
            Enable Camera
          </button>
        </div>

        <!-- Requesting -->
        <div *ngIf="cameraStatus === 'requesting'" class="alert alert-warning">
          <i class="fas fa-spinner fa-spin"></i>
          Please allow camera access in the browser prompt.
        </div>

        <!-- Success -->
        <div *ngIf="cameraStatus === 'success'" class="alert alert-success">
          <i class="fas fa-check-circle"></i>
          Camera access granted!
        </div>

        <!-- Error -->
        <div *ngIf="cameraStatus === 'error'" class="alert alert-danger">
          <i class="fas fa-exclamation-circle"></i>
          {{ cameraErrorMessage }}
          <button (click)="initializeCamera()" class="btn btn-danger ml-2">
            Try Again
          </button>
        </div>

        <!-- Permission Denied -->
        <div *ngIf="cameraStatus === 'denied'" class="alert alert-danger">
          <i class="fas fa-ban"></i>
          Camera permission was denied. Please enable it in your browser
          settings.
          <button (click)="initializeCamera()" class="btn btn-danger ml-2">
            Try Again
          </button>
        </div>
      </div>
      <div *ngIf="cameraStatus === 'success'">
        <mat-grid-list
          rowHeight="80px"
          [cols]="screenSize === ScreenType.Mobile ? 1 : 3"
          gutterSize="5px"
        >
          <mat-grid-tile
            [colspan]="screenSize === ScreenType.Mobile ? 1 : 2"
            [rowspan]="screenSize === ScreenType.Mobile ? 4 : 5"
          >
            <div class="open-camera-visitor-entry">
              <div *ngIf="showWebcam">
                <webcam
                  [trigger]="invokeObservable"
                  [videoOptions]="videoOptions"
                  [switchCamera]="nextWebcamObservable"
                  (imageCapture)="captureImg($event)"
                  [width]="screenSize === ScreenType.Mobile ? 280 : 350"
                  [height]="screenSize === ScreenType.Mobile ? 330 : 400"
                  [allowCameraSwitch]="true"
                  [imageQuality]="1"
                ></webcam>
              </div>
              <div *ngIf="!showWebcam" class="captured-image-container">
                <img [src]="sysImage" />
              </div>

              <div class="open-camera-button">
                <div></div>
              </div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field subscriptSizing="dynamic" appearance="outline">
              <mat-label>Select Camera</mat-label>
              <mat-select
                [value]="deviceSelected"
                (valueChange)="onDeviceSelectChange($event)"
              >
                <mat-option
                  *ngFor="let device of availableDevices"
                  [value]="device.deviceId"
                  >{{ device.label }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="mat-tile-button">
              <button
                [disabled]="!isDeviceSelected || isApiFetching"
                (click)="getSnapshot()"
                mat-raised-button
              >
                {{ sysImage ? "ReCapture" : "Capture" }}
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            [rowspan]="2"
            *ngIf="isClickedSubmit && screenSize === ScreenType.Mobile"
          >
            <div class="submit-result">
              <mat-spinner *ngIf="isApiFetching"></mat-spinner>
              <div *ngIf="isFaceMatched" class="matched">Matched</div>
              <div *ngIf="isError" class="notmatched">Not Matched</div>
            </div>
          </mat-grid-tile>
          <mat-grid-tile>
            <div class="mat-tile-button">
              <button
                [disabled]="!sysImage || !currentLocation || isApiFetching"
                (click)="onClickSubmit()"
                mat-raised-button
              >
                Submit
              </button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile
            [rowspan]="2"
            *ngIf="isClickedSubmit && screenSize != ScreenType.Mobile"
          >
            <div class="submit-result">
              <mat-spinner *ngIf="isApiFetching"></mat-spinner>
              <div *ngIf="isFaceMatched" class="matched">Matched</div>
              <div
                *ngIf="isError && !isLocationError && !isAnotherErr"
                class="notmatched"
              >
                Not Matched
              </div>
              <div
                *ngIf="isError && isLocationError && !isAnotherErr"
                class="not-matched"
              >
                Location not matched
              </div>
              <div *ngIf="isError && isAnotherErr" class="not-matched">
                Api Error
              </div>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </div>
  </div>
</div>
